import selectorConstants from './constants';
import { selectStateData } from './data';

export const selectPagination = (Model, defaultPagination) => (state) => {
  const pagination = selectStateData(Model.NAME, 'pagination')(state);

  if (!pagination) {
    return defaultPagination;
  }

  return pagination;
};

export const selectFilters = (Model) => (state) => {
  const filtersData = selectStateData(Model.NAME, 'filters')(state);

  return filtersData || selectorConstants.EMPTY_OBJECT;
};

export const selectSortBy = (Model, defaultSortBy) => (state) => {
  const sortByData = selectStateData(Model.NAME, 'sortBy')(state);

  if (!sortByData) {
    return defaultSortBy;
  }

  return sortByData;
};
